document.addEventListener('DOMContentLoaded', function () {
  console.log('%c[SYSTEM] All modules online.', 'color:#38e1ff;background:#0a0e14;font-family:monospace;padding:4px;');
});

(function () {
  function initGalleries(root) {
    root.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryReady) return;
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
      if (!main || thumbs.length < 2) return;
      gallery.dataset.galleryReady = 'true';
      var index = Math.max(0, thumbs.findIndex(function (thumb) { return thumb.getAttribute('aria-current') === 'true'; }));
      var status = gallery.querySelector('[data-gallery-status]');
      function show(next) {
        index = (next + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        main.src = thumb.href;
        main.alt = thumb.dataset.imageAlt;
        main.width = Number(thumb.dataset.imageWidth);
        main.height = Number(thumb.dataset.imageHeight);
        thumbs.forEach(function (item, i) {
          if (i === index) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        status.textContent = 'Photo ' + (index + 1) + ' of ' + thumbs.length;
      }
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function (event) { event.preventDefault(); show(i); });
      });
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { show(index - 1); });
      gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { show(index + 1); });
      gallery.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      var start = null;
      var stage = gallery.querySelector('[data-gallery-stage]');
      stage.addEventListener('touchstart', function (event) {
        start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!start || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - start.x;
        var dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      stage.addEventListener('touchcancel', function () { start = null; }, { passive: true });
      show(index);
      gallery.querySelector('[data-gallery-controls]').hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initGalleries(document); });
  else initGalleries(document);
  document.addEventListener('shopify:section:load', function (event) { initGalleries(event.target); });
})();
